const Hero = () => {
  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center bg-black pt-16 relative overflow-hidden"
    >
      {/* Subtle gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-black to-gray-900 opacity-50"></div>
      
      {/* Minimal accent line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-64 bg-gradient-to-b from-white to-transparent opacity-10"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mx-4 lg:mx-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="order-2 md:order-1 space-y-6">
            <div>
              <p className="text-white text-sm tracking-widest uppercase font-light opacity-60">
                Hello, I&apos;m
              </p>
              <h1 className="text-white text-5xl sm:text-6xl lg:text-7xl font-light leading-tight mt-2">
                Nadishan<br />Danthanarayana
              </h1>
            </div>

            <p className="text-gray-400 text-lg sm:text-xl max-w-lg font-light leading-relaxed">
              A developer crafting elegant digital experiences with modern web and mobile technologies.
            </p>

            <div className="pt-4 flex flex-col sm:flex-row gap-4">
              <button
                onClick={() =>
                  document
                    .querySelector('#contact')
                    ?.scrollIntoView({ behavior: 'smooth' })
                }
                className="bg-white text-black px-8 py-3 text-sm font-medium tracking-wide hover:bg-gray-200 transition-colors duration-300 border border-white"
              >
                Connect with Me
              </button>

              <button
                onClick={() =>
                  document
                    .querySelector('#projects')
                    ?.scrollIntoView({ behavior: 'smooth' })
                }
                className="border border-gray-700 text-white px-8 py-3 text-sm font-medium tracking-wide hover:border-white hover:bg-white hover:text-black transition-all duration-300"
              >
                View Projects
              </button>
            </div>
          </div>

          {/* Right Content - Profile Image */}
          <div className="order-1 md:order-2 flex justify-center md:justify-end mt-[35px] md:mt-0">
            <div className="relative">
              <div className="w-64 h-64 sm:w-72 sm:h-72 lg:w-96 lg:h-96 rounded-[15px] overflow-hidden border border-gray-800">
                <img
                  src="/assets/nadishan.png"
                  alt="Nadishan Danthanarayana"
                  className="w-full h-full object-cover transition-all duration-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;